module.exports = __webpack_public_path__ + "static/media/pin.cd565f5f.svg";